import { IDashboard } from '@literax/models/dashboard.model';

export interface IDashboardState {
  dashboard: IDashboard
}

export const initialDashboardState: IDashboardState = {
  dashboard: null
};
